"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LabeledCheckbox = _interopRequireDefault(require("../LabeledCheckbox"));

var _BooleanListItem = require("./BooleanListItem.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BooleanListItem = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(BooleanListItem, _React$PureComponent);

  var _super = _createSuper(BooleanListItem);

  function BooleanListItem() {
    var _this;

    _classCallCheck(this, BooleanListItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e, value) {
      return _this.props.onChange && _this.props.onChange({
        id: _this.props.id,
        value: value === 'yes'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "formatId", function (displayId) {
      if (displayId) {
        return /*#__PURE__*/_react.default.createElement("strong", {
          "data-test-id": "boolean-list-item-display-id",
          className: "c-boolean-list-item-index"
        }, displayId, ".");
      }

      return null;
    });

    return _this;
  }

  _createClass(BooleanListItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          displayId = _this$props.displayId,
          dataTestId = _this$props.dataTestId,
          id = _this$props.id,
          itemTitle = _this$props.itemTitle,
          value = _this$props.value;
      return /*#__PURE__*/_react.default.createElement(_BooleanListItem.StyledBooleanListItem, {
        className: className,
        "data-test-id": dataTestId
      }, /*#__PURE__*/_react.default.createElement(_BooleanListItem.StyledIndex, null, displayId && /*#__PURE__*/_react.default.createElement("div", null, this.formatId(displayId))), /*#__PURE__*/_react.default.createElement(_BooleanListItem.StyledWrapper, null, /*#__PURE__*/_react.default.createElement("span", {
        "data-test-id": "boolean-list-item-title"
      }, itemTitle), /*#__PURE__*/_react.default.createElement("div", {
        className: "c-boolean-list-item-space-around-checkboxes"
      }, /*#__PURE__*/_react.default.createElement(_LabeledCheckbox.default, {
        checked: value === true,
        checkedIconName: "check-circle",
        dataTestId: "boolean-list-item-yes",
        id: "yes".concat(id),
        label: "Yes",
        name: "yes".concat(id),
        onChange: this.handleChange,
        uncheckedIconName: "circle",
        value: "yes"
      }), /*#__PURE__*/_react.default.createElement(_LabeledCheckbox.default, {
        checked: value === false,
        checkedIconName: "check-circle",
        className: "c-boolean-list-item-space-between",
        dataTestId: "boolean-list-item-yes",
        label: "No",
        name: "no".concat(id),
        onChange: this.handleChange,
        uncheckedIconName: "circle",
        value: "no"
      }))));
    }
  }]);

  return BooleanListItem;
}(_react.default.PureComponent);

_defineProperty(BooleanListItem, "propTypes", {
  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Optional index to be displayed to the left of title */
  displayId: _propTypes.default.string,

  /** Name of this unique instance of the Boolean List */
  id: _propTypes.default.string,

  /** Title that gets displayed */
  itemTitle: _propTypes.default.string.isRequired,

  /** Onchange Handler */
  onChange: _propTypes.default.func.isRequired,

  /** value of component */
  value: _propTypes.default.bool
});

_defineProperty(BooleanListItem, "defaultProps", {
  className: '',
  displayId: '',
  id: '',
  value: undefined
});

var _default = BooleanListItem;
exports.default = _default;